import React, { useRef, useState } from 'react';

import { t } from '@/utility/localization';

import Modal from '@/components/common/Modal';
import NPLButton from '@/components/npl/NPLButton';

import useUrlList from '../../hooks/useUrlList';
import { isValidUrl } from '../../hooks/useUrlList';
import InputList from '../InputList';

const AddLinkModal = (props) => {
  const { open, onClose, onSubmit } = props;
  const [input, setInput] = useState('');
  const inputListRef = useRef();
  const { urlList, deleteUrl, addUrl } = useUrlList();

  return (
    <Modal
      open={open}
      showCloseIcon
      onClose={onClose}
      customContainerClass="max-w-[680px]"
      customInnerClass="c-PortalContent-AddLinkModal !p-0">
      <div>
        <h3 className="flex h-56 items-center border-b-1 border-npl-neutral-light-solid-6 px-24 text-heading-xs font-semibold">
          {t('add-link1')}
        </h3>
        {/* Form */}
        <div className="p-24">
          <InputList
            ref={inputListRef}
            setInput={setInput}
            itemList={urlList}
            addItem={addUrl}
            deleteItem={deleteUrl}
          />
        </div>
        {/* Cta */}
        <div className="flex h-64 items-center justify-end space-x-16 border-t-1 border-npl-neutral-light-solid-6 px-24">
          <NPLButton
            hierarchy="outline"
            onClick={onClose}
            buttonText={t('cancel')}
          />
          <NPLButton
            disabled={!input || !isValidUrl({ url: input })}
            hierarchy="accent_primary"
            onClick={() => onSubmit({ list: urlList })}
            buttonText={t('save')}
          />
        </div>
      </div>
    </Modal>
  );
};

export default AddLinkModal;
